import { Toast, Dialog as VantDialog } from 'vant';
import ProcessDialog from '@/components/processDialog';
import { freeOrder, queryVrbtStatus } from '@/api/modules/miguBJHY';
import { loadMiguSdKScript } from '@/utils/index';
import { checkMobile } from '@/api/modules/phone';
import { queryTopic } from '@/api/modules/subject';
import { loginSecret } from '@/api/modules/migu';
import { CarrierType } from '@/model/CarrierType';
import { track } from '@/directives/track/send.js';
import sourceApi from '@/api/modules/source';
import { VrbtStatusType } from '@/model/VrbtStatus';
import router from '@/router';
// 类型断言
export const processDialog = ProcessDialog;
// 类型断言
export const Dialog = VantDialog;
// 处理咪咕关闭事件的函数
function handleMIGUClose(dom, videoInstance, currentPlay) {
    console.log(videoInstance, currentPlay);
    const processDialogElement = window.document.querySelector('#process-dialog');
    const observer = new MutationObserver(function (mutations, observer) {
        mutations.forEach(function (mutationRecord) {
            // 获取监听的dom节点中style为display的值赋予loading
            if (mutationRecord.target instanceof HTMLElement && mutationRecord.target.style) {
                const value = mutationRecord.target.style.getPropertyValue('display');
                // 只有进度条消失 且 display变为none 判定是migu订单弹窗收起
                if (value === 'none' &&
                    processDialogElement &&
                    processDialogElement instanceof HTMLElement &&
                    processDialogElement.style.display === 'none') {
                    if (currentPlay) {
                        videoInstance?.play();
                    }
                    observer.disconnect();
                }
                else if (value === 'block') {
                    // 此过程拉起订购页
                    videoInstance?.pause();
                    processDialog.close();
                    Toast.clear();
                    // track([{ event_id: 'h5_color_ring_link_order_page_success', event_param: { content_name: CarrierType.ENUM[state.carrierType], carrier_name: CarrierType.ENUM[state.carrierType] } }])
                }
            }
        });
    });
    dom && observer.observe(dom, { attributes: true, attributeFilter: ['style'] });
}
// Window对象扩展已在shims-other.d.ts中声明declare
const miguUnionPackage = {
    namespaced: true,
    state: () => {
        return {
            token: '',
            phone: window.localStorage.getItem('bjhy-phone') || '',
            ringId: '600926000012307643',
            isLogin: !!(window.localStorage.getItem('bjhy-phone') && window.localStorage.getItem('bjhy-phone') !== undefined),
            phoneProvince: '',
            settingData: {},
            channelData: {
                channelCode: '00211PT',
                serviceId: '698039020104031421'
            }
        };
    },
    mutations: {
        SET_LOGIN(state, isLogin) {
            state.isLogin = !!isLogin;
        },
        SET_CHANNEL_DATA(state, channelData) {
            state.channelData.channelCode = channelData.channelCode;
            state.channelData.serviceId = channelData.serviceId;
        },
        SET_PHONE: (state, phone) => {
            state.phone = phone;
        },
        SET_PHONE_PROVINCE(state, province) {
            state.phoneProvince = province;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_RING_ID: (state, ringId) => {
            state.ringId = ringId;
        },
        SET_SETTING_VIDEOID(state, ringId) {
            state.settingData.videoId = ringId;
        },
        SET_SETTING_PRODUCT_ID(state, productId) {
            state.settingData.productId = productId;
        },
        SET_SETTING_CONTENT_ID(state, contentId) {
            state.settingData.contentId = contentId;
        },
        SET_SETTING_CROPYRINGHT_ID(state, copyRightID) {
            state.settingData.copyRightID = copyRightID;
        }
    },
    actions: {
        // 获取彩铃列表
        getRingList({ commit }, payload) {
            return new Promise((resolve) => {
                queryTopic({ subjectId: payload }).then((res) => {
                    commit('appStore/SET_TOPIC_CONFIG', { ...res.data }, { root: true });
                    if (res.data && res.data.ringContentVOList) {
                        const arr = res.data.ringContentVOList.map((item) => {
                            return {
                                ...item,
                                videoSrc: item.filePath,
                                posterSrc: item.previewPath,
                                homePosterSrc: item.homePreviewPath,
                                sourceType: item.ispType.toString(),
                                id: item.ringId,
                                desc: item.ringName,
                                title: item.ringName
                            };
                        });
                        resolve(arr);
                    }
                    else {
                        resolve([]);
                    }
                });
            });
        },
        // // 运营商检查
        checkMobileActions({ commit, state, rootState, dispatch }, payload) {
            debugger;
            // dispatch('checkMobileTrack', { type: '10', res: '', isSuccess: false, carrierName: '' })
            // dispatch('handleActionApi', {
            //   isp: '',
            //   token: '',
            //   phone: payload,
            //   action: '10',
            //   interfaceName: 'api/checkMobile',
            //   resCode: '',
            //   resMessage: ''
            // })
            return new Promise((resolve, reject) => {
                console.log(rootState, 'rootState');
                checkMobile({
                    phone: payload,
                    pcid: rootState.RouteModule.pcid
                })
                    .then((res) => {
                    dispatch('handleActionApi', {
                        isp: '',
                        token: '',
                        phone: payload,
                        action: '11',
                        interfaceName: 'api/checkMobile',
                        resCode: res.code,
                        resMessage: JSON.stringify(res)
                    });
                    // 异常处理
                    if (res && res.code === '5000') {
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res,
                            isSuccess: false,
                            carrierName: ''
                        });
                        Toast.fail({
                            message: res.message || '请求失败'
                        });
                        reject(res.message || '请求失败');
                    }
                    else {
                        // 正常返回。但针对广电提醒 && (status === 1)
                        const { type, detail, status } = res.data || {};
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res,
                            isSuccess: true,
                            carrierName: type
                        });
                        if (type !== CarrierType.MIGU) {
                            reject(res.message || '非移动号码，无法开通！');
                        }
                        else if (status === 1) {
                            const isSame = Number(type) === Number(state.carrierType);
                            commit('SET_PHONE_PROVINCE', detail && detail[0] ? detail[0] : '');
                            resolve({ type, isSame });
                        }
                        else {
                            const message = `抱歉，您所在的区域${detail && detail[0] ? `(${detail[0]})` : ''}暂时不支持使用该视频彩铃服务，敬请谅解！`;
                            Toast.fail({
                                message
                            });
                            reject(res.message || message);
                        }
                    }
                })
                    .catch(() => {
                    Toast.clear();
                });
            });
        },
        // 确认登录
        confirmLogin({ state, commit }) {
            commit('SET_LOGIN', true);
            // 登录则存手机号
            if (state.phone) {
                window.localStorage.setItem('bjhy-phone', state.phone);
            }
            else {
                window.localStorage.removeItem('bjhy-phone');
            }
        },
        // 登录获取token
        loginSecreat({ state, rootState, commit, dispatch }) {
            Toast.loading({
                duration: 0
            });
            return new Promise((resolve, reject) => {
                debugger;
                const channelKey = rootState.app.configData.ring_bjhy_channel_key;
                let channelData = rootState.app.configData[channelKey];
                if (rootState.RouteModule.query.bjhyk === 'pu') {
                    const channelKey2 = rootState.app.configData.ring_bjhy_channel_key2;
                    channelData = rootState.app.configData[channelKey2];
                }
                else if (rootState.RouteModule.query.bjhyk === 'ps') {
                    const channelKey3 = rootState.app.configData.ring_bjhy_channel_key3;
                    channelData = rootState.app.configData[channelKey3];
                }
                try {
                    channelData = JSON.parse(channelData);
                    commit('SET_CHANNEL_DATA', channelData);
                }
                catch (err) {
                    console.log(err, 'SET_CHANNEL_DATA');
                    channelData = {
                        channelCode: '00211PT',
                        serviceId: '698039020104031421'
                    };
                }
                // dispatch('checkMobileTrack', { type: '41', res: '', isSuccess: false, carrierName: '' })
                // dispatch('handleActionApi', {
                //   isp: '',
                //   token: '',
                //   phone: state.phone,
                //   action: '41',
                //   interfaceName: 'api/loginSecret',
                //   resCode: '',
                //   resMessage: ''
                // })
                loginSecret({
                    loginType: 3,
                    mobile: state.phone,
                    pcid: rootState.RouteModule.query.picd,
                    channelCode: channelData.channelCode
                })
                    .then((res) => {
                    dispatch('checkMobileTrack', { type: '42', res, isSuccess: true, carrierName: CarrierType.MIGU });
                    dispatch('handleActionApi', {
                        isp: '',
                        token: '',
                        phone: state.phone,
                        action: '42',
                        interfaceName: 'api/loginSecret',
                        resCode: res.code,
                        resMessage: JSON.stringify(res)
                    });
                    commit('SET_TOKEN', res.data.token);
                    resolve(res.data);
                })
                    .catch((err) => {
                    reject(err);
                });
            });
        },
        checkPackage2({ state }) {
            return new Promise((resolve, reject) => {
                // Promise.all([
                //   loadMiguSdKScript('https://hz.migu.cn/order/pub-ui/js/and/migus.js', 'migu'),
                //   loadMiguSdKScript('https://hz.migu.cn/order/pub-ui/js/and/openMusicSDK.js', 'openMusicSDK')
                // ])
                Promise.all([
                    loadMiguSdKScript('./migus-https.js', 'migu'),
                    loadMiguSdKScript('./openMusicSDK-https.js', 'openMusicSDK')
                ]).then(() => {
                    window.miguBJYHQueryFn = (res) => {
                        if (res.resCode !== '000000') {
                            reject(new Error(res.resMsg));
                        }
                        else {
                            const { status } = res;
                            if (status === '1') {
                                reject(new Error('nopackage'));
                            }
                            else if (status === '0') {
                                resolve('existPackage');
                            }
                        }
                    };
                    const query = {
                        youCallbackName: 'miguBJYHQueryFn',
                        channelCode: state.channelData.channelCode,
                        token: state.token,
                        serviceId: state.channelData.serviceId
                    };
                    // Use consistent type assertion approach
                    if (typeof window.miguBJYHQuery === 'function') {
                        window.miguBJYHQuery(query);
                    }
                    else {
                        console.error('miguBJYHQuery function not available');
                        reject(new Error('nopackage'));
                    }
                });
            });
        },
        async checkPackage({ state, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                Promise.all([
                    loadMiguSdKScript('./migus-https.js', 'migu'),
                    loadMiguSdKScript('./openMusicSDK-https.js', 'openMusicSDK')
                ]).then(() => {
                    window.miguBJYHQueryFn = (res) => {
                        dispatch('checkMobileTrack', { type: '44', res, isSuccess: true, carrierName: CarrierType.MIGU });
                        dispatch('handleActionApi', {
                            isp: '',
                            token: '',
                            phone: state.phone,
                            action: '44',
                            interfaceName: 'sdk/miguBJYHQuery',
                            resCode: res.resCode,
                            resMessage: JSON.stringify(res)
                        });
                        if (res.resCode !== '000000') {
                            Toast.fail({
                                message: res.resMsg,
                                forbidClick: true,
                                duration: 2000
                            });
                        }
                        else {
                            const { status } = res;
                            console.log(res, 'miguBJYHQuery');
                            if (status === '1') {
                                // 不存在包
                                processDialog();
                                Toast.clear();
                                // dispatch('notExistPackage', payload)
                                reject(new Error('nopackage'));
                            }
                            else if (status === '0') {
                                // 存在包
                                // dispatch('existPackage', payload)
                                resolve('existPackage');
                            }
                        }
                    };
                    const query = {
                        youCallbackName: 'miguBJYHQueryFn',
                        channelCode: state.channelData.channelCode,
                        token: state.token,
                        serviceId: state.channelData.serviceId
                    };
                    // Use consistent type assertion approach
                    if (typeof window.miguBJYHQuery === 'function') {
                        // dispatch('checkMobileTrack', { type: '43', res: '', isSuccess: true, carrierName: '' })
                        // dispatch('handleActionApi', {
                        //   isp: '',
                        //   token: '',
                        //   phone: state.phone,
                        //   action: '43',
                        //   interfaceName: 'api/loginSecret',
                        //   resCode: '',
                        //   resMessage: ''
                        // })
                        console.log(query, '查询包');
                        window.miguBJYHQuery(query);
                    }
                    else {
                        console.error('miguBJYHQuery function not available');
                        Toast.fail({
                            message: '服务暂不可用，请稍后再试',
                            forbidClick: true,
                            duration: 2000
                        });
                        dispatch('checkMobileTrack', { type: '44', res: 'miguBJYHQuery function not available', isSuccess: false, carrierName: '' });
                        dispatch('handleActionApi', {
                            isp: '',
                            token: '',
                            phone: state.phone,
                            action: '44',
                            interfaceName: 'init/miguBJYHQuery',
                            resCode: '',
                            resMessage: 'miguBJYHQuery function not available'
                        });
                    }
                });
            });
        },
        existPackage({ dispatch, state }, payload) {
            debugger;
            const set = !!payload.set;
            // dispatch('checkMobileTrack', { type: '45', res: '', isSuccess: false, carrierName: '' })
            // dispatch('handleActionApi', {
            //   isp: '',
            //   token: '',
            //   phone: state.phone,
            //   action: '45',
            //   interfaceName: 'api/queryVrbtStatus',
            //   resCode: '',
            //   resMessage: ''
            // })
            // 判断是否有主叫视频彩铃功能
            queryVrbtStatus({
                token: state.token,
                channelCode: state.channelData.channelCode
            }).then((res) => {
                dispatch('checkMobileTrack', { type: '46', res, isSuccess: true, carrierName: '' });
                dispatch('handleActionApi', {
                    isp: '',
                    token: '',
                    phone: state.phone,
                    action: '46',
                    interfaceName: 'api/queryVrbtStatus',
                    resCode: res.code,
                    resMessage: res.data
                });
                if (res && (res.data === VrbtStatusType.Close || res.data === VrbtStatusType.Open)) {
                    dispatch('miguBJYHOrderQuest', { serviceId: '600923018000000007', ringStatus: true, ...payload });
                }
                else {
                    processDialog.close();
                    if (set) {
                        // 设置彩铃
                        dispatch('setFreeRing');
                    }
                    else {
                        Toast.fail({
                            message: '您已开通！',
                            forbidClick: true,
                            duration: 2000
                        });
                    }
                }
            });
        },
        notExistPackage({ dispatch, state }, payload) {
            queryVrbtStatus({
                token: state.token,
                channelCode: state.channelData.channelCode
            }).then((res) => {
                if (res && (res.data === VrbtStatusType.Close || res.data === VrbtStatusType.Open)) {
                    dispatch('miguBJYHOrderQuest', { serviceId: state.channelData.serviceId, ringStatus: true, ...payload });
                }
                else {
                    dispatch('perMonthCartOrder', { serviceId: state.channelData.serviceId + ',600923018000000007', ...payload });
                }
            });
        },
        // 白金会员花费订购
        miguBJYHOrderQuest({ state, rootState, dispatch }, payload) {
            debugger;
            let videoInstance = null;
            let currentPlay = false;
            if (payload) {
                videoInstance = payload.video;
                currentPlay = !!payload.currentPlay;
            }
            const { serviceId } = payload;
            const params = {
                youCallbackName: 'queryStrategyBJYH',
                channelCode: state.channelData.channelCode,
                token: state.token,
                serviceId,
                count: '1',
                type: '14'
            };
            processDialog();
            Toast.clear();
            window.queryStrategyBJYH = (res) => {
                dispatch('checkMobileTrack', { type: '49', res, isSuccess: true, carrierName: CarrierType.MIGU });
                dispatch('handleActionApi', {
                    isp: '',
                    token: '',
                    phone: state.phone,
                    action: '49',
                    interfaceName: 'sdk/queryStrategyBYB',
                    resCode: res.resCode,
                    resMessage: JSON.stringify(res)
                });
                debugger;
                if (!res.bizInfoMon) {
                    processDialog.close();
                    Toast.fail({
                        message: res.resMsg || '请求失败',
                        forbidClick: true,
                        duration: 2000
                    });
                    return;
                }
                const { cpId, bizCode, cpparam, salePrice } = res.bizInfoMon;
                const miguBJYHOrderparams = {
                    youCallbackName: 'miguBJYHOrderFn',
                    channelCode: state.channelData.channelCode,
                    token: state.token,
                    serviceId: serviceId,
                    name: 'miguBJYHOrder',
                    excode: '',
                    defSeq: `${rootState.RouteModule.query.pcid ?? ''}` +
                        '_' +
                        state.settingData.videoId +
                        '_' +
                        state.settingData.copyRightID,
                    cpId,
                    bizCode,
                    cpparam,
                    salePrice
                };
                window.miguBJYHOrderFn = (res) => {
                    if (res.resCode === '000000') {
                        // 有主叫功能
                        Dialog.alert({
                            title: '咪咕音乐白金会员畅听(视频彩铃版)D已开通成功，立即生效。',
                            theme: 'round-button',
                            message: `1、咪咕音乐白金会员畅听版权益已生效，用订购业务对应的手机号码登录咪咕音乐APP即可使用权益。

2、视频彩铃权益已生效，可设置本专区视频彩铃内容，或用订购业务对应的手机号码进入微信公众号“天机云锦-玩转彩铃”设置视频彩铃。`,
                            className: 'bs-op-dialog'
                        }).then(() => {
                            router.push({
                                name: 'miguBJYH-result',
                                query: {
                                    bjhyk: rootState.RouteModule.query.bjhyk
                                }
                            });
                        });
                        dispatch('confirmLogin');
                    }
                    else {
                        if (!res.resMsg?.includes('用户取消支付') && (res.resCode !== '0001' || res.resCode !== '0002' || res.resCode !== '000000')) {
                            processDialog.close();
                            const failedMessage = rootState.app.configData.sdkmessage ? rootState.app.configData.sdkmessage : '网络异常，请重试';
                            Dialog.alert({ message: failedMessage, showConfirmButton: false, className: 'failed-dialog' });
                            setTimeout(() => {
                                Dialog.close();
                            }, 2000);
                        }
                    }
                };
                if (typeof window.miguBJYHOrder === 'function') {
                    sourceApi.channelAdd({
                        mobile: state.phone,
                        ringId: state.settingData.videoId,
                        type: ~~CarrierType.MIGU,
                        operationChannel: state.channelData.channelCode,
                        promotionChannel: router.currentRoute.query.pcid,
                        url: window.location.href
                    });
                    window.miguBJYHOrder(miguBJYHOrderparams);
                }
                else {
                    console.error('miguBJYHOrder function not available');
                    processDialog.close();
                    Toast.fail({
                        message: '服务暂不可用，请稍后再试',
                        forbidClick: true,
                        duration: 2000
                    });
                }
                // 确保样式设置成功如果过早设置样式top会被覆盖
                setTimeout(() => {
                    const div = window.document.querySelector('#miguPayTag');
                    handleMIGUClose(div, videoInstance, currentPlay);
                }, 1000);
            };
            window.openCallFun = (res) => {
                dispatch('checkMobileTrack', { type: '48', res: res, isSuccess: true, carrierName: CarrierType.MIGU });
                dispatch('handleActionApi', {
                    isp: '',
                    token: '',
                    phone: state.phone,
                    action: '48',
                    interfaceName: 'sdk/openMiGuInit',
                    resCode: res.code,
                    resMessage: res.resMsg
                });
                console.log(res);
                debugger;
                // if (res.resultCode !== '000000') {
                //   processDialog.close()
                //   Toast.fail({
                //     message: res.msg || '请求失败',
                //     forbidClick: true,
                //     duration: 2000
                //   })
                //   return
                // }
                // if ((res.resCode !== '0001' || res.resCode !== '0002' || res.resCode !== '000000')) {
                //   processDialog.close()
                //   const failedMessage = rootState.app.configData.sdkmessage ? rootState.app.configData.sdkmessage : '网络异常，请重试'
                //   Dialog.alert({ message: failedMessage, showConfirmButton: false, className: 'failed-dialog' })
                //   setTimeout(() => {
                //     Dialog.close()
                //   }, 2000)
                //   return
                // }
                if (typeof window.queryStrategyBYB === 'function') {
                    console.log('这里的49');
                    // dispatch('checkMobileTrack', { type: '49', res: res, isSuccess: false, carrierName: CarrierType.MIGU })
                    // dispatch('handleActionApi', {
                    //   isp: '',
                    //   token: '',
                    //   phone: state.phone,
                    //   action: '49',
                    //   interfaceName: 'sdk/queryStrategyBYB',
                    //   resCode: '',
                    //   resMessage: ''
                    // })
                    window.queryStrategyBYB(params);
                }
                else {
                    console.error('queryStrategyBYB function not available');
                    processDialog.close();
                    Toast.fail({
                        message: '服务暂不可用，请稍后再试',
                        forbidClick: true,
                        duration: 2000
                    });
                    dispatch('checkMobileTrack', { type: '50', res: 'queryStrategyBYB function not available', isSuccess: false, carrierName: CarrierType.MIGU });
                    dispatch('handleActionApi', {
                        isp: '',
                        token: '',
                        phone: state.phone,
                        action: '50',
                        interfaceName: 'sdk/queryStrategyBYB',
                        resCode: '',
                        resMessage: 'queryStrategyBYB function not available'
                    });
                }
            };
            if (typeof window.openMiGuInit === 'function') {
                // dispatch('checkMobileTrack', { type: '47', res: '', isSuccess: false, carrierName: CarrierType.MIGU })
                // dispatch('handleActionApi', {
                //   isp: '',
                //   token: '',
                //   phone: state.phone,
                //   action: '47',
                //   interfaceName: 'sdk/openMiGuInit',
                //   resCode: '',
                //   resMessage: ''
                // })
                window.openMiGuInit(state.channelData.channelCode, 'openCallFun', 'mconf', '', '');
            }
            else {
                console.error('openMiGuInit function not available');
                Toast.fail({
                    message: '服务暂不可用，请稍后再试',
                    forbidClick: true,
                    duration: 2000
                });
                dispatch('checkMobileTrack', { type: '48', res: 'openMiGuInit function not available', isSuccess: false, carrierName: CarrierType.MIGU });
                dispatch('handleActionApi', {
                    isp: '',
                    token: '',
                    phone: state.phone,
                    action: '48',
                    interfaceName: 'sdk/openMiGuInit',
                    resCode: '',
                    resMessage: 'openMiGuInit function not available'
                });
            }
        },
        checkMobileTrack(context, payload) {
            console.log(payload);
            const { type, res, isSuccess, carrierName } = payload;
            if (res && res.data && res.data.detail) {
                const [province, city] = res.data.detail;
                const sensors = window.sensorsDataAnalytic201505;
                sensors.registerPage({
                    province,
                    city
                });
            }
            debugger;
            const params = {
                h5_color_ring_order_api_event_type: type,
                is_success: isSuccess || false,
                error_code: !isSuccess ? res.code || res.resCode || res.resultCode : '',
                error_msg: JSON.stringify(res),
                carrier_name: ''
            };
            console.log(params);
            if (carrierName) {
                params.carrier_name = CarrierType.ENUM[carrierName];
            }
            track([{ event_id: 'h5_color_ring_order_api_event', event_param: params }]);
        },
        handleActionApi({ rootState }, data) {
            sourceApi.actionlogApi({
                ...data,
                pid: rootState.app.selfInfo['dev-pid'],
                uid: rootState.app.selfInfo.uid,
                cookieId: rootState.app.cookieId
            });
        },
        setFreeRing({ state, rootState, commit, dispatch }) {
            const channelKey = rootState.app.configData.ring_bjhy_channel_key;
            let channelData = rootState.app.configData[channelKey];
            if (rootState.RouteModule.query.bjhyk === '00211PU') {
                const channelKey2 = rootState.app.configData.ring_bjhy_channel_key2;
                channelData = rootState.app.configData[channelKey2];
            }
            else if (rootState.RouteModule.query.bjhyk === '00211PS') {
                const channelKey3 = rootState.app.configData.ring_bjhy_channel_key3;
                channelData = rootState.app.configData[channelKey3];
            }
            try {
                channelData = JSON.parse(channelData);
                commit('SET_CHANNEL_DATA', channelData);
            }
            catch (err) {
                channelData = {
                    channelCode: '00211PT',
                    serviceId: '698039020104031421'
                };
            }
            const params = {
                token: state.token,
                channelCode: channelData.channelCode,
                ringId: state.settingData.videoId || ''
            };
            freeOrder(params)
                .then((res) => {
                dispatch('checkMobileTrack', { type: '54', res, isSuccess: res.code === '0000', carrierName: CarrierType.MIGU });
                dispatch('handleActionApi', {
                    isp: '',
                    token: '',
                    phone: state.phone,
                    action: '54',
                    interfaceName: 'api/freeOrder',
                    resCode: res.code,
                    resMessage: JSON.stringify(res)
                });
                Toast.clear();
                if (res.code === '0000') {
                    Toast.success({
                        message: '设置成功',
                        forbidClick: true,
                        duration: 2000
                    });
                }
                else {
                    Toast.fail({
                        message: res.message,
                        forbidClick: true,
                        duration: 2000
                    });
                }
            })
                .catch(() => {
                Toast.clear();
            });
        },
        // 包月订购
        perMonthCartOrder({ state, rootState, dispatch }, payload) {
            debugger;
            let videoInstance = null;
            let currentPlay = false;
            if (payload) {
                videoInstance = payload.video;
                currentPlay = !!payload.currentPlay;
            }
            const { serviceId } = payload;
            window.openAndMonthGWCBJHY = (res) => {
                dispatch('checkMobileTrack', { type: '54', res, isSuccess: res.resCode === '000000', carrierName: CarrierType.MIGU });
                dispatch('handleActionApi', {
                    isp: '',
                    token: '',
                    phone: state.phone,
                    action: '54',
                    interfaceName: 'sdk/openAndMonthGWC',
                    resCode: res.resCode,
                    resMessage: JSON.stringify(res)
                });
                debugger;
                if (res.resCode === '000000') {
                    Dialog.alert({
                        title: '咪咕音乐白金会员畅听(视频彩铃版)D已开通成功，立即生效。',
                        theme: 'round-button',
                        message: `1、咪咕音乐白金会员畅听版权益已生效，用订购业务对应的手机号码登录咪咕音乐APP即可使用权益。

2、视频彩铃权益已生效，可设置本专区视频彩铃内容，或用订购业务对应的手机号码进入微信公众号“天机云锦-玩转彩铃”设置视频彩铃。`,
                        className: 'bs-op-dialog'
                    }).then(() => {
                        router.push({
                            name: 'miguBJYH-result',
                            query: {
                                bjhyk: rootState.RouteModule.query.bjhyk
                            }
                        });
                    });
                    dispatch('confirmLogin');
                }
                else {
                    if (!res.resMsg?.includes('用户取消支付') && (res.resCode !== '0001' || res.resCode !== '0002' || res.resCode !== '000000')) {
                        processDialog.close();
                        const failedMessage = rootState.app.configData.sdkmessage ? rootState.app.configData.sdkmessage : '网络异常，请重试';
                        Dialog.alert({ message: failedMessage, showConfirmButton: false, className: 'failed-dialog' });
                        setTimeout(() => {
                            Dialog.close();
                        }, 2000);
                    }
                }
            };
            const openAndMonthGWCParams = {
                youCallbackName: 'openAndMonthGWCBJHY',
                channelCode: state.channelData.channelCode,
                token: state.token,
                serviceId,
                excode: '',
                defSeq: `${rootState.RouteModule.query.pcid ?? ''}` +
                    '_' +
                    state.settingData.videoId +
                    '_' +
                    state.settingData.copyRightID
            };
            console.log(openAndMonthGWCParams, 'openAndMonthGWCParams');
            if (typeof window.openMiGuInit === 'function') {
                // dispatch('checkMobileTrack', { type: '51', res: '', isSuccess: false, carrierName: CarrierType.MIGU })
                // dispatch('handleActionApi', {
                //   isp: '',
                //   token: '',
                //   phone: state.phone,
                //   action: '51',
                //   interfaceName: 'sdk/openMiGuInit',
                //   resCode: '',
                //   resMessage: ''
                // })
                window.openMiGuInit(state.channelData.channelCode, 'openCallFun2', 'mconf', '', '');
            }
            else {
                console.error('openMiGuInit function not available');
                Toast.fail({
                    message: '服务暂不可用，请稍后再试',
                    forbidClick: true,
                    duration: 2000
                });
                dispatch('checkMobileTrack', { type: '52', res: 'openMiGuInit function not available', isSuccess: false, carrierName: CarrierType.MIGU });
                dispatch('handleActionApi', {
                    isp: '',
                    token: '',
                    phone: state.phone,
                    action: '52',
                    interfaceName: 'sdk/openMiGuInit',
                    resCode: '',
                    resMessage: 'openMiGuInit function not available'
                });
                return;
            }
            window.openCallFun2 = (res) => {
                dispatch('checkMobileTrack', { type: '52', res: res.resMsg, isSuccess: true, carrierName: CarrierType.MIGU });
                dispatch('handleActionApi', {
                    isp: '',
                    token: '',
                    phone: state.phone,
                    action: '52',
                    interfaceName: 'sdk/openMiGuInit',
                    resCode: res.code,
                    resMessage: res.resMsg
                });
                // if (res.resultCode !== '000000') {
                //   processDialog.close()
                //   Toast.fail({
                //     message: res.msg || '请求失败',
                //     forbidClick: true,
                //     duration: 2000
                //   })
                //   return
                // }
                // if ((res.resCode !== '0001' || res.resCode !== '0002' || res.resCode !== '000000')) {
                //   processDialog.close()
                //   const failedMessage = rootState.app.configData.sdkmessage ? rootState.app.configData.sdkmessage : '网络异常，请重试'
                //   Dialog.alert({ message: failedMessage, showConfirmButton: false, className: 'failed-dialog' })
                //   setTimeout(() => {
                //     Dialog.close()
                //   }, 2000)
                //   return
                // }
                Toast.clear();
                processDialog();
                // Use type assertion to avoid TypeScript error
                const win = window;
                if (typeof win.openAndMonthGWC === 'function') {
                    // dispatch('checkMobileTrack', { type: '53', res: '', isSuccess: false, carrierName: CarrierType.MIGU })
                    // dispatch('handleActionApi', {
                    //   isp: '',
                    //   token: '',
                    //   phone: state.phone,
                    //   action: '53',
                    //   interfaceName: 'sdk/openAndMonthGWC',
                    //   resCode: '',
                    //   resMessage: ''
                    // })
                    sourceApi.channelAdd({
                        mobile: state.phone,
                        ringId: state.settingData.videoId,
                        type: ~~CarrierType.MIGU,
                        operationChannel: state.channelData.channelCode,
                        promotionChannel: router.currentRoute.query.pcid,
                        url: window.location.href
                    });
                    win.openAndMonthGWC(openAndMonthGWCParams);
                }
                else {
                    console.error('openAndMonthGWC function not available');
                    processDialog.close();
                    Toast.fail({
                        message: '服务暂不可用，请稍后再试',
                        forbidClick: true,
                        duration: 2000
                    });
                    dispatch('checkMobileTrack', { type: '54', res: '', isSuccess: false, carrierName: CarrierType.MIGU });
                    dispatch('handleActionApi', {
                        isp: '',
                        token: '',
                        phone: state.phone,
                        action: '54',
                        interfaceName: 'sdk/openAndMonthGWC',
                        resCode: '',
                        resMessage: 'openAndMonthGWC function not available'
                    });
                }
                // 确保样式设置成功如果过早设置样式top会被覆盖
                setTimeout(() => {
                    const div = window.document.querySelector('#miguPayTag');
                    handleMIGUClose(div, videoInstance, currentPlay);
                }, 1000);
            };
        },
        // 白金会员退订
        miguBJYHOrderCancel({ state }) {
            debugger;
            const data = {
                youCallbackName: 'miguBJYHCancelFn',
                channelCode: state.channelData.channelCode,
                token: state.token,
                serviceId: state.channelData.serviceId
            };
            window.miguBJYHCancelFn = (res) => {
                Toast.info(res.resMsg);
            };
            window.miguBJHYCancel(data);
        }
    }
};
export default miguUnionPackage;
